export default __webpack_public_path__ + "static/media/react.7098e271.svg";